import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleModelEditor = ({
  tradeId,
  initialModel,
}: {
  tradeId: Trade['id'];
  initialModel: string;
}) => {
  const [model, setModel] = useState(initialModel);

  const updateModelMutation = useMutation({
    onMutate: async ({ model }: { model: string }) => {
      tradesStore.updateTrade(tradeId, {
        model: model,
      });
    },
    mutationFn: async ({ model }: { model: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/model`,
        // /api/trades/:trade_id/model
        {
          model,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating model', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleModelChange = useCallback(
    debounce((newModel: string) => {
      updateModelMutation.mutate({ model: newModel });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (model === initialModel) return;

    handleModelChange(model);
  }, [model]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setModel(e.target.value);
  }, []);

  useEffect(() => {
    setModel(initialModel);
  }, [initialModel]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">Model</div>
      </div>
      <InlineTextInput
        value={model}
        onChange={onChange}
        placeholder="Enter model"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleModelEditor;
